import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const useCurrentAssetId = (): string | undefined => {
  const { assetId } = useParams<{ assetId: string }>();
  const location = useLocation();

  return useMemo(() => assetId, [assetId, location.pathname]);
};
